require('./bootstrap');

import { createApp, h, provide } from 'vue';
import { App, plugin } from "@inertiajs/inertia-vue3";
import { Inertia } from "@inertiajs/inertia";
import { InertiaProgress } from "@inertiajs/progress";

InertiaProgress.init();

import router from '@/router';

const el = document.getElementById('app');

const app = createApp({
    render: () => h(App, {
        initialPage: JSON.parse(el.dataset.page),
        resolveComponent: (name) => import(`./Pages/${name}`).then(module => module.default),
    }),
}).use(plugin);

app.config.globalProperties.$route = router;

app.mount(el);
